// import closepan from 'images/integration-logos/closepan.avif';
import acton from 'images/integration-logos/act-on.png';
import addresstools from 'images/integration-logos/addresstools.png';
import adobesign from 'images/integration-logos/adobesign.png';
import adroll from 'images/integration-logos/adroll.png';
import aeon2 from 'images/integration-logos/aeon2.png';
import affectlayer from 'images/integration-logos/affectlayer.svg';
import agilevizart from 'images/integration-logos/agilevizart.png';
import aha from 'images/integration-logos/aha.svg';
import airbyte from 'images/integration-logos/airbyte.svg';
import airfocus from 'images/integration-logos/airfocus.svg';
import airtable from 'images/integration-logos/airtable.svg';
import alienvault from 'images/integration-logos/alienvault.png';
import allbound from 'images/integration-logos/allbound.svg';
import alpharun from 'images/integration-logos/alpharun.png';
import altify from 'images/integration-logos/altify.png';
import alyce from 'images/integration-logos/alyce.png';
import amazonappflow from 'images/integration-logos/amazonappflow.svg';
import ambition from 'images/integration-logos/ambition.png';
import amplemarket from 'images/integration-logos/amplemarket.svg';
import apollo from 'images/integration-logos/apollo.svg';
import appcues from 'images/integration-logos/appcues.svg';
import appfrontier from 'images/integration-logos/appfrontier.png';
import appomni from 'images/integration-logos/appomni.svg';
import aptrinsic from 'images/integration-logos/aptrinsic.svg';
import arcticwolf from 'images/integration-logos/arcticwolf.png';
import armatic from 'images/integration-logos/armatic.png';
import arovy from 'images/integration-logos/ArovyLogo-Blue.svg';
import ascendixsearch from 'images/integration-logos/ascendixsearch.png';
import asknicely from 'images/integration-logos/asknicely.png';
import atlan from 'images/integration-logos/atlan.png';
import atlassian from 'images/integration-logos/atlassian.svg';
import avature from 'images/integration-logos/Avature.svg';
import awesometable from 'images/integration-logos/awesometable.png';
import aws from 'images/integration-logos/aws.svg';
import azuredatafactory from 'images/integration-logos/AzureDataFactory.svg';
import azurepurview from 'images/integration-logos/AzurePurview.svg';
import base from 'images/integration-logos/base.png';
import benefitflow from 'images/integration-logos/benefitflow.png';
import bizible from 'images/integration-logos/bizible.png';
import blackthorn from 'images/integration-logos/Blackthorn.svg';
import blissfully from 'images/integration-logos/blissfully.svg';
import bluebirds from 'images/integration-logos/bluebirds.png';
import bluecanvas from 'images/integration-logos/bluecanvas.png';
import board from 'images/integration-logos/board.svg';
import bofc from 'images/integration-logos/bofc.png';
import bombora from 'images/integration-logos/bombora.svg';
import boomi from 'images/integration-logos/boomi.svg';
import brainshark from 'images/integration-logos/brainshark.png';
import brightback from 'images/integration-logos/brightback.png';
import brightfunnel from 'images/integration-logos/brightfunnel.png';
import calendly from 'images/integration-logos/calendly.svg';
import callrail from 'images/integration-logos/callrail.svg';
import capchase from 'images/integration-logos/capchase.svg';
import captivateiq from 'images/integration-logos/captivateiq.svg';
import carrierdownloads from 'images/integration-logos/CarrierDownloads.svg';
import catalyst from 'images/integration-logos/catalyst.png';
import celigo from 'images/integration-logos/Celigo.svg';
import cellarstone from 'images/integration-logos/cellarstone.png';
import celoxis from 'images/integration-logos/celoxis.png';
import census from 'images/integration-logos/census.png';
import certain from 'images/integration-logos/Certain.svg';
import chameleon from 'images/integration-logos/chameleon.svg';
import chargebee from 'images/integration-logos/chargebee.svg';
import chatbots from 'images/integration-logos/chatbots.png';
import checkout from 'images/integration-logos/checkout.svg';
import chilipiper from 'images/integration-logos/ChiliPiper.svg';
import churnzero from 'images/integration-logos/ChurnZero.svg';
import cirrusinsight from 'images/integration-logos/cirrusinsight.png';
import clari from 'images/integration-logos/Clari.svg';
import clay from 'images/integration-logos/clay.png';
import clearbit from 'images/integration-logos/clearbit.svg';
import clickup from 'images/integration-logos/clickup.svg';
import clientportal from 'images/integration-logos/clientportal.png';
import clientsuccess from 'images/integration-logos/clientsuccess.png';
import closefactor from 'images/integration-logos/closefactor.png';
import cloud4j from 'images/integration-logos/cloud4j.png';
import cloudanswers from 'images/integration-logos/cloudanswers.png';
import cloudingo from 'images/integration-logos/Cloudingo.svg';
import coachem from 'images/integration-logos/coachem.png';
import coeifficient from 'images/integration-logos/Coefficient.svg';
import cognisim from 'images/integration-logos/Cognisim.svg';
import collibra from 'images/integration-logos/Collibra.svg';
import commvault from 'images/integration-logos/CommVault.svg';
import concur from 'images/integration-logos/SAPConcur.svg';
import configworkbook from 'images/integration-logos/configworkbook.png';
import conga from 'images/integration-logos/Conga.svg';
import connectandsell from 'images/integration-logos/connectandsell.png';
import constantcontact from 'images/integration-logos/constantcontact.svg';
import contactclean from 'images/integration-logos/contactclean.png';
import contactout from 'images/integration-logos/contactout.png';
import conversica from 'images/integration-logos/conversica.svg';
import conveyor from 'images/integration-logos/conveyor.png';
import copado from 'images/integration-logos/copado.svg';
import correlated from 'images/integration-logos/Correlated.svg';
import cpoms from 'images/integration-logos/CPOMS.svg';
import crayon from 'images/integration-logos/crayon.png';
import crmperks from 'images/integration-logos/crmperks.png';
import crossbeam from 'images/integration-logos/crossbeam.svg';
import crowdvocate from 'images/integration-logos/crowdvocate.png';
import crunchbase from 'images/integration-logos/crunchbase.svg';
import ctu from 'images/integration-logos/ctu.png';
import cvent from 'images/integration-logos/cvent.svg';
import dataanalytics from 'images/integration-logos/DataAnalytics.svg';
import databox from 'images/integration-logos/databox.svg';
import datachef from 'images/integration-logos/Datachef.svg';
import datadog from 'images/integration-logos/datadog.svg';
import datafox from 'images/integration-logos/datafox.png';
import dataiku from 'images/integration-logos/dataiku.svg';
import dataloader from 'images/integration-logos/DataLoader.svg';
import dataloaderio from 'images/integration-logos/DataLoaderIO.svg';
import datamask from 'images/integration-logos/datamask.png';
import { DataSecurityAppName } from './DataSecurityAppNames';
import dealhub from 'images/integration-logos/dealhub.svg';
import defhc from 'images/integration-logos/defhc.png';
import delighted from 'images/integration-logos/delighted.svg';
import demandbase from 'images/integration-logos/demandbase.svg';
import demandtools from 'images/integration-logos/demandtools.png';
import desk from 'images/integration-logos/desk.png';
import dialpad from 'images/integration-logos/dialpad.png';
import discoverorg from 'images/integration-logos/discoverorg.png';
import discoverydata from 'images/integration-logos/discoverydata.svg';
import dms from 'images/integration-logos/dms.png';
import docsend from 'images/integration-logos/docsend.svg';
import docufree from 'images/integration-logos/docufree.png';
import docusign from 'images/integration-logos/docusign.png';
import dooly from 'images/integration-logos/Dooly.svg';
import drift from 'images/integration-logos/drift.svg';
import dunandbradstreet from 'images/integration-logos/dunandbradstreet.svg';
import ebsta from 'images/integration-logos/ebsta.png';
import efile from 'images/integration-logos/efile.png';
import ekla from 'images/integration-logos/ekla.png';
import enosix from 'images/integration-logos/enosix.png';
import equilar from 'images/integration-logos/equilar.svg';
import exalate from 'images/integration-logos/exalate.svg';
import fathom from 'images/integration-logos/fathom.svg';
import fieldcreator from 'images/integration-logos/fieldcreator.png';
import fifteenfive from 'images/integration-logos/15five.svg';
import financialforce from 'images/integration-logos/financialforce.png';
import five9 from 'images/integration-logos/five9.png';
import fivetran from 'images/integration-logos/Fivetran.svg';
import fleetio from 'images/integration-logos/fleetio.svg';
import flosom from 'images/integration-logos/flosom.svg';
import flow from 'images/integration-logos/flow.png';
import fluxcapacity from 'images/integration-logos/fluxcapacity.png';
import folderize from 'images/integration-logos/folderize.png';
import formassembly from 'images/integration-logos/FormAssembly.svg';
import freshdesk from 'images/integration-logos/freshdesk.svg';
import front from 'images/integration-logos/front.png';
import fullcircle from 'images/integration-logos/fullcircle.png';
import g2crowd from 'images/integration-logos/g2crowd.png';
import gainsight from 'images/integration-logos/gainsight.svg';
import gearset from 'images/integration-logos/gearset.svg';
import geckoboard from 'images/integration-logos/geckoboard.svg';
import genesys from 'images/integration-logos/genesys.png';
import geopointe from 'images/integration-logos/geopointe.png';
import getfeedback from 'images/integration-logos/getfeedback.svg';
import glean from 'images/integration-logos/glean.svg';
import gong from 'images/integration-logos/gong.svg';
import google from 'images/integration-logos/google.svg';
import googleads from 'images/integration-logos/googleads.svg';
import grafana from 'images/integration-logos/grafana.svg';
import grain from 'images/integration-logos/grain.svg';
import gridbuddy from 'images/integration-logos/gridbuddy.png';
import groove from 'images/integration-logos/groove.svg';
import guide from 'images/integration-logos/guide.svg';
import hackerone from 'images/integration-logos/hackerone.svg';
import headlight from 'images/integration-logos/headlight.png';
import heap from 'images/integration-logos/heap.png';
import hellosign from 'images/integration-logos/hellosign.png';
import heroku from 'images/integration-logos/heroku.svg';
import heymarket from 'images/integration-logos/heymarket.svg';
import hgdata from 'images/integration-logos/hgdata.png';
import highspot from 'images/integration-logos/Highspot.svg';
import hightouch from 'images/integration-logos/Hightouch.svg';
import hippovideo from 'images/integration-logos/hippovideo.png';
import hockeystack from 'images/integration-logos/HockeyStack.svg';
import hubspot from 'images/integration-logos/hubspot.svg';
import ienterprises from 'images/integration-logos/ienterprises.png';
import impartner from 'images/integration-logos/impartner.svg';
import informatica from 'images/integration-logos/informatica.png';
import inmoment from 'images/integration-logos/InMoment.svg';
import insided from 'images/integration-logos/insided.png';
import insights from 'images/integration-logos/insights.png';
import insightsquared from 'images/integration-logos/insightsquared.svg';
import instapage from 'images/integration-logos/instapage.svg';
import insycle from 'images/integration-logos/insycle.png';
import intacct from 'images/integration-logos/intacct.png';
import integratorio from 'images/integration-logos/integratorio.png';
import intercom from 'images/integration-logos/intercom.svg';
import introhive from 'images/integration-logos/introhive.svg';
import ironclad from 'images/integration-logos/Ironclad.svg';
import jira from 'images/integration-logos/Jira.svg';
import khoros from 'images/integration-logos/khoros.png';
import kimble from 'images/integration-logos/kimble.png';
import kingswaysoft from 'images/integration-logos/KingswaySoft.svg';
import kixie from 'images/integration-logos/Kixie.svg';
import kochava from 'images/integration-logos/kochava.svg';
import koncert from 'images/integration-logos/koncert.svg';
import leadfeeder from 'images/integration-logos/leadfeeder.svg';
import leadiq from 'images/integration-logos/leadiq.svg';
import leandata from 'images/integration-logos/LeanData.svg';
import learnupon from 'images/integration-logos/learnupon.svg';
import linen from 'images/integration-logos/linen.png';
import linkedin from 'images/integration-logos/LinkedIn.svg';
import linkpoint360 from 'images/integration-logos/linkpoint360.png';
import linksquares from 'images/integration-logos/linksquares.svg';
import livechat from 'images/integration-logos/livechat.svg';
import liveperson from 'images/integration-logos/liveperson.svg';
import lms from 'images/integration-logos/lms.png';
import loop from 'images/integration-logos/loop.png';
import loopio from 'images/integration-logos/loopio.png';
import lucidchart from 'images/integration-logos/lucidchart.svg';
import lusha from 'images/integration-logos/Lusha.svg';
import madcap from 'images/integration-logos/madcap.png';
import madkudu from 'images/integration-logos/madkudu.svg';
import maestroqa from 'images/integration-logos/maestroqa.svg';
import magentrix from 'images/integration-logos/magentrix.png';
import magicmover from 'images/integration-logos/magicmover.png';
import mailchimp from 'images/integration-logos/mailchimp.png';
import make from 'images/integration-logos/make.svg';
import malbek from 'images/integration-logos/malbek.png';
import marketo from 'images/integration-logos/marketo.svg';
import matik from 'images/integration-logos/matik.png';
import maxio from 'images/integration-logos/Maxio.svg';
import microsoft from 'images/integration-logos/microsoft.svg';
import milestones from 'images/integration-logos/milestones.png';
import mindtickle from 'images/integration-logos/mindtickle.svg';
import missioncontrol from 'images/integration-logos/missioncontrol.png';
import modigie from 'images/integration-logos/modigie.png';
import monday from 'images/integration-logos/Monday.svg';
import movableink from 'images/integration-logos/MovableInk.svg';
import msci from 'images/integration-logos/MSCI.svg';
import mulesoft from 'images/integration-logos/mulesoft.svg';
import multiview from 'images/integration-logos/multiview.png';
import nc2 from 'images/integration-logos/nc2.png';
import ncino from 'images/integration-logos/ncino.png';
import netchex from 'images/integration-logos/netchex.svg';
import netskope from 'images/integration-logos/netskope.svg';
import netsuite from 'images/integration-logos/netsuite.svg';
import niceincontact from 'images/integration-logos/niceincontact.png';
import nightfall from 'images/integration-logos/nightfall.svg';
import nintex from 'images/integration-logos/nintex.svg';
import npsp from 'images/integration-logos/npsp.png';
import okta from 'images/integration-logos/Okta.svg';
import oktopost from 'images/integration-logos/oktopost.png';
import oneclickupdate from 'images/integration-logos/1clickupdate.png';
import oneflow from 'images/integration-logos/oneflow.svg';
import onetrust from 'images/integration-logos/OneTrust.svg';
import onramp from 'images/integration-logos/OnRamp.svg';
import orchestrate from 'images/integration-logos/orchestrate.png';
import orgchartplus from 'images/integration-logos/orgchartplus.png';
import orum from 'images/integration-logos/orum.svg';
import outreach from 'images/integration-logos/outreach.png';
import pagerduty from 'images/integration-logos/PagerDuty.svg';
import pandadoc from 'images/integration-logos/pandadoc.svg';
import pardot from 'images/integration-logos/sfpardot.png';
import pendo from 'images/integration-logos/Pendo.svg';
import peopleai from 'images/integration-logos/peopleai.png';
import pipe17 from 'images/integration-logos/pipe17.png';
import pitchbook from 'images/integration-logos/pitchbook.svg';
import planhat from 'images/integration-logos/planhat.png';
import polytomic from 'images/integration-logos/polytomic.svg';
import powerbi from 'images/integration-logos/PowerBI.svg';
import productboard from 'images/integration-logos/productboard.svg';
import productiv from 'images/integration-logos/Productiv.svg';
import propel from 'images/integration-logos/propel.png';
import qualified from 'images/integration-logos/Qualified.svg';
import qualtrics from 'images/integration-logos/qualtrics.svg';
import quickbase from 'images/integration-logos/quickbase.svg';
import quip from 'images/integration-logos/quip.svg';
import quotapath from 'images/integration-logos/quotapath.svg';
import qwilr from 'images/integration-logos/qwilr.png';
import rampmetrics from 'images/integration-logos/rampmetrics.png';
import reachdesk from 'images/integration-logos/Reachdesk.svg';
import referenceedge from 'images/integration-logos/referenceedge.png';
import regieai from 'images/integration-logos/regieai.svg';
import retool from 'images/integration-logos/retool.svg';
import reveal from 'images/integration-logos/Reveal.svg';
import revenuegrid from 'images/integration-logos/revenuegrid.png';
import revsend from 'images/integration-logos/revsend.png';
import rightrev from 'images/integration-logos/rightrev.png';
import ringdna from 'images/integration-logos/ringdna.png';
import rippling from 'images/integration-logos/Rippling.svg';
import rocketlane from 'images/integration-logos/rocketlane.svg';
import rolluphelper from 'images/integration-logos/rolluphelper.png';
import rollupsummary from 'images/integration-logos/rollupsummary.png';
import salesforce from 'images/integration-logos/salesforce.svg';
import salesforceiq from 'images/integration-logos/SalesforceIQ.svg';
import saleshood from 'images/integration-logos/saleshood.png';
import salesinsights from 'images/integration-logos/salesinsights.png';
import salesloft from 'images/integration-logos/salesloft.svg';
import salesscreen from 'images/integration-logos/salesscreen.svg';
import scratchpad from 'images/integration-logos/Scratchpad.svg';
import searchunify from 'images/integration-logos/searchunify.png';
import secoda from 'images/integration-logos/secoda.svg';
import seismic from 'images/integration-logos/seismic.svg';
import sendoso from 'images/integration-logos/sendoso.svg';
import sfagileaccelerator from 'images/integration-logos/sfagileaccelerator.png';
import sfappexchange from 'images/integration-logos/sfappexchange.png';
import sfbilling from 'images/integration-logos/sfbilling.png';
import sfchatter from 'images/integration-logos/sfchatter.png';
import sfcommunities from 'images/integration-logos/sfcommunities.png';
import sfconnappsadmin from 'images/integration-logos/sfconnappsadmin.png';
import sfconnectedapps from 'images/integration-logos/sfconnectedapps.png';
import sfdatacom from 'images/integration-logos/sfdatacom.png';
import sfinbox from 'images/integration-logos/sfinbox.png';
import sfmaps from 'images/integration-logos/sfmaps.png';
import sfmarketingcloud from 'images/integration-logos/sfmarketingcloud.png';
import showpad from 'images/integration-logos/showpad.svg';
import sifdata from 'images/integration-logos/sifdata.png';
import sigstr from 'images/integration-logos/sigstr.png';
import simpplr from 'images/integration-logos/simpplr.png';
import sixsense from 'images/integration-logos/6sense.svg';
import skilljar from 'images/integration-logos/skilljar.svg';
import slack from 'images/integration-logos/slack.svg';
import slapdash from 'images/integration-logos/slapdash.png';
import smartling from 'images/integration-logos/smartling.svg';
import snforsfdc from 'images/integration-logos/snforsfdc.png';
import spanningbackup from 'images/integration-logos/spanningbackup.png';
import spekit from 'images/integration-logos/spekit.svg';
import spiff from 'images/integration-logos/spiff.svg';
import spoton from 'images/integration-logos/spoton.svg';
import squivr from 'images/integration-logos/squivr.png';
import stackmoxie from 'images/integration-logos/stackmoxie.png';
import startdeliver from 'images/integration-logos/startdeliver.png';
import steelbrick from 'images/integration-logos/steelbrick.png';
import sumologic from 'images/integration-logos/sumologic.svg';
import superhuman from 'images/integration-logos/Superhuman.svg';
import supermetrics from 'images/integration-logos/supermetrics.svg';
import surveymonkey from 'images/integration-logos/SurveyMonkey.svg';
import switchgrowth from 'images/integration-logos/switch.svg';
import tableau from 'images/integration-logos/Tableau.svg';
import talkdesk from 'images/integration-logos/talkdesk.svg';
import taskray from 'images/integration-logos/taskray.png';
import techtarget from 'images/integration-logos/techtarget.png';
import terminus from 'images/integration-logos/terminus.png';
import tesorio from 'images/integration-logos/tesorio.svg';
import thnks from 'images/integration-logos/thnks.svg';
import tibco from 'images/integration-logos/tibco.png';
import tonkean from 'images/integration-logos/tonkean.svg';
import totango from 'images/integration-logos/totango.svg';
import tractionguest from 'images/integration-logos/tractionguest.svg';
import tractionhierarchies from 'images/integration-logos/tractionhierarchies.png';
import trailhead from 'images/integration-logos/trailhead.png';
import trayio from 'images/integration-logos/Trayio.svg';
import trustradius from 'images/integration-logos/trustradius.png';
import twitter from 'images/integration-logos/twitter.png';
import uipath from 'images/integration-logos/UIPath.svg';
import ukg from 'images/integration-logos/ukg.svg';
import unify from 'images/integration-logos/unify.png';
import usergems from 'images/integration-logos/usergems.svg';
import uservoice from 'images/integration-logos/uservoice.svg';
import validity from 'images/integration-logos/validity.svg';
import valooto from 'images/integration-logos/valooto.png';
import valuecloud from 'images/integration-logos/valuecloud.png';
import vanta from 'images/integration-logos/vanta.svg';
import varonis from 'images/integration-logos/Varonis.svg';
import veza from 'images/integration-logos/veza.png';
import vidyard from 'images/integration-logos/vidyard.svg';
import vista from 'images/integration-logos/vista.png';
import visualantidote from 'images/integration-logos/visualantidote.png';
import vivun from 'images/integration-logos/vivun.png';
import vonage from 'images/integration-logos/Vonage.svg';
import walkme from 'images/integration-logos/walkme.svg';
import webinfinity from 'images/integration-logos/webinfinity.png';
import whatfix from 'images/integration-logos/whatfix.svg';
import wootric from 'images/integration-logos/wootric.png';
import workato from 'images/integration-logos/Workato.svg';
import workramp from 'images/integration-logos/workramp.svg';
import xactly from 'images/integration-logos/xactly.svg';
import xactlyexpress from 'images/integration-logos/xactlyexpress.png';
import xappex from 'images/integration-logos/xappex.svg';
import xplenty from 'images/integration-logos/xplenty.svg';
import yaypay from 'images/integration-logos/yaypay.png';
import yesware from 'images/integration-logos/yesware.png';
import yoCierge from 'images/integration-logos/yocierge.png';
import zapier from 'images/integration-logos/Zapier.svg';
import zendesk from 'images/integration-logos/zendesk.svg';
import zenkraft from 'images/integration-logos/zenkraft.png';
import zigpr from 'images/integration-logos/zigpr.png';
import zoom from 'images/integration-logos/zoom.svg';
import zoominfo from 'images/integration-logos/zoominfo.svg';
import zuora from 'images/integration-logos/zuora.svg';
import zylo from 'images/integration-logos/Zylo.svg';
export const DataSecurityAppLogos = {
    // closepan - wrong file format
    [DataSecurityAppName.ActOn]: acton,
    [DataSecurityAppName.AddressTools]: addresstools,
    [DataSecurityAppName.AdobeSign]: adobesign,
    [DataSecurityAppName.AdminAgentsAI]: null,
    [DataSecurityAppName.Adroll]: adroll,
    [DataSecurityAppName.AdWords]: googleads,
    [DataSecurityAppName.Aeon2]: aeon2,
    [DataSecurityAppName.AffectLayer]: affectlayer,
    [DataSecurityAppName.AgathaAnswers]: null,
    [DataSecurityAppName.AgileVizArt]: agilevizart,
    [DataSecurityAppName.AgileVizArtChatter]: agilevizart,
    [DataSecurityAppName.Aha]: aha,
    [DataSecurityAppName.AIPlatformAuth]: null,
    [DataSecurityAppName.Airbyte]: airbyte,
    [DataSecurityAppName.Airfocus]: airfocus,
    [DataSecurityAppName.Airtable]: airtable,
    [DataSecurityAppName.AlienVault]: alienvault,
    [DataSecurityAppName.Allbound]: allbound,
    [DataSecurityAppName.Alpharun]: alpharun,
    [DataSecurityAppName.Altify]: altify,
    [DataSecurityAppName.Alyce]: alyce,
    [DataSecurityAppName.AmazonAppFlow]: amazonappflow,
    [DataSecurityAppName.AmazonAppFlowEmbedded]: amazonappflow,
    [DataSecurityAppName.AmazonConnectProd]: null,
    [DataSecurityAppName.AmazonGlue]: null,
    [DataSecurityAppName.Ambassador]: null,
    [DataSecurityAppName.Ambition]: ambition,
    [DataSecurityAppName.Amplemarket]: amplemarket,
    [DataSecurityAppName.AnalyticsDataImport]: null,
    [DataSecurityAppName.AnalyticsForiOS]: null,
    [DataSecurityAppName.AnecdotesAI]: null,
    [DataSecurityAppName.AnecdotesIntegration]: null,
    [DataSecurityAppName.ApexGuru]: null,
    [DataSecurityAppName.Apollo]: apollo,
    [DataSecurityAppName.Appcues]: appcues,
    [DataSecurityAppName.AppExchange]: sfappexchange,
    [DataSecurityAppName.AppExchangePublishing]: sfappexchange,
    [DataSecurityAppName.AppFrontier]: appfrontier,
    [DataSecurityAppName.AppOmni]: appomni,
    [DataSecurityAppName.AppXAPI]: null,
    [DataSecurityAppName.Aptrinsic]: aptrinsic,
    [DataSecurityAppName.ArcticWolf]: arcticwolf,
    [DataSecurityAppName.Armatic]: armatic,
    [DataSecurityAppName.ArticleQuality]: null,
    [DataSecurityAppName.AscendixSearch]: ascendixsearch,
    [DataSecurityAppName.AskAI]: null,
    [DataSecurityAppName.AskNicely]: asknicely,
    [DataSecurityAppName.AtlanConnector]: atlan,
    [DataSecurityAppName.AtlanDataManagement]: atlan,
    [DataSecurityAppName.AtlassianLinks]: atlassian,
    [DataSecurityAppName.Atrium]: null,
    [DataSecurityAppName.Auction]: null,
    [DataSecurityAppName.Avature]: avature,
    [DataSecurityAppName.Aviator]: null,
    [DataSecurityAppName.AwesomeTableConnector]: awesometable,
    [DataSecurityAppName.AWS]: aws,
    [DataSecurityAppName.AzureDataFactory]: azuredatafactory,
    [DataSecurityAppName.AzureLogicApps]: null,
    [DataSecurityAppName.AzurePurview]: azurepurview,
    [DataSecurityAppName.BackupAndRestore]: null,
    [DataSecurityAppName.Base]: base,
    [DataSecurityAppName.BenefitFlow]: benefitflow,
    [DataSecurityAppName.BenefitFlowIntegration]: benefitflow,
    [DataSecurityAppName.Berry]: null,
    [DataSecurityAppName.Beynd]: null,
    [DataSecurityAppName.BIUser]: null,
    [DataSecurityAppName.Bizible]: bizible,
    [DataSecurityAppName.BizzaboEventManagement]: null,
    [DataSecurityAppName.Blackthorn]: blackthorn,
    [DataSecurityAppName.Blissfully]: blissfully,
    [DataSecurityAppName.Bluebirds]: bluebirds,
    [DataSecurityAppName.BlueCanvas]: bluecanvas,
    [DataSecurityAppName.BlueCanvasCPQ]: bluecanvas,
    [DataSecurityAppName.Board]: board,
    [DataSecurityAppName.Bombora]: bombora,
    [DataSecurityAppName.Boomi]: boomi,
    [DataSecurityAppName.BoomiSlash]: boomi,
    [DataSecurityAppName.Brainshark]: brainshark,
    [DataSecurityAppName.BriefingSource]: null,
    [DataSecurityAppName.Brightback]: brightback,
    [DataSecurityAppName.BrightFunnel]: brightfunnel,
    [DataSecurityAppName.Browser]: null,
    [DataSecurityAppName.BulkObjectCreator]: bofc,
    [DataSecurityAppName.Cabal]: null,
    [DataSecurityAppName.Calendly]: calendly,
    [DataSecurityAppName.CallRail]: callrail,
    [DataSecurityAppName.Capchase]: capchase,
    [DataSecurityAppName.CaptivateIQ]: captivateiq,
    [DataSecurityAppName.CarrierDownloads]: carrierdownloads,
    [DataSecurityAppName.Catalyst]: catalyst,
    [DataSecurityAppName.CCCGamification]: null,
    [DataSecurityAppName.CDataConnector]: null,
    [DataSecurityAppName.Celigo]: celigo,
    [DataSecurityAppName.Celigo2]: celigo,
    [DataSecurityAppName.CeligoNetsuite]: celigo,
    [DataSecurityAppName.CeligoNetSuitePackage]: celigo,
    [DataSecurityAppName.Cellarstone]: cellarstone,
    [DataSecurityAppName.Celoxis]: celoxis,
    [DataSecurityAppName.CEMDigitalExperience]: null,
    [DataSecurityAppName.Census]: census,
    [DataSecurityAppName.Certain]: certain,
    [DataSecurityAppName.Chameleon]: chameleon,
    [DataSecurityAppName.ChameleonIO]: chameleon,
    [DataSecurityAppName.Channeled]: null,
    [DataSecurityAppName.ChargeBee]: chargebee,
    [DataSecurityAppName.Chatbots]: chatbots,
    [DataSecurityAppName.Checkout]: checkout,
    [DataSecurityAppName.ChiliPiper]: chilipiper,
    [DataSecurityAppName.ChiliPiperSalesAcceleration]: chilipiper,
    [DataSecurityAppName.ChurnZero]: churnzero,
    [DataSecurityAppName.ChurnZero2]: churnzero,
    [DataSecurityAppName.ChurnZeroApp]: churnzero,
    [DataSecurityAppName.ChurnZeroConnectedApp]: churnzero,
    [DataSecurityAppName.CirrusInsight]: cirrusinsight,
    [DataSecurityAppName.CirrusInsightServices]: cirrusinsight,
    [DataSecurityAppName.Clari]: clari,
    [DataSecurityAppName.ClariCopilot]: clari,
    [DataSecurityAppName.ClariWebProd]: clari,
    [DataSecurityAppName.Clarius]: null,
    [DataSecurityAppName.Clay]: clay,
    [DataSecurityAppName.Clearbit]: clearbit,
    [DataSecurityAppName.ClearbitSalesforceSync]: clearbit,
    [DataSecurityAppName.ClickDeploy]: null,
    [DataSecurityAppName.ClickUp]: clickup,
    [DataSecurityAppName.ClientPortal]: clientportal,
    [DataSecurityAppName.ClientSuccess]: clientsuccess,
    [DataSecurityAppName.ClientSupportSite]: null,
    [DataSecurityAppName.CloseFactor]: closefactor,
    [DataSecurityAppName.CloseFactorDev]: closefactor,
    [DataSecurityAppName.ClosePlan]: null,
    [DataSecurityAppName.Cloud4JReportBuilder]: cloud4j,
    [DataSecurityAppName.CloudAnswers]: cloudanswers,
    [DataSecurityAppName.Cloudingo]: cloudingo,
    [DataSecurityAppName.CloudingoAgent]: cloudingo,
    [DataSecurityAppName.CoachEm]: coachem,
    [DataSecurityAppName.Coefficient]: coeifficient,
    [DataSecurityAppName.Cognisim]: cognisim,
    [DataSecurityAppName.CognisimChrome]: cognisim,
    [DataSecurityAppName.Collibra]: collibra,
    [DataSecurityAppName.CommonRoom]: null,
    [DataSecurityAppName.CommVault]: commvault,
    [DataSecurityAppName.Composer]: null,
    [DataSecurityAppName.ComposerLightning]: null,
    [DataSecurityAppName.Concur]: concur,
    [DataSecurityAppName.ConcurConnector]: concur,
    [DataSecurityAppName.ConfigWorkbookTool]: configworkbook,
    [DataSecurityAppName.Conga]: conga,
    [DataSecurityAppName.CongaApprovals]: conga,
    [DataSecurityAppName.CongaCLM]: conga,
    [DataSecurityAppName.CongaComposer]: conga,
    [DataSecurityAppName.CongaPlatform]: conga,
    [DataSecurityAppName.CongaPlatformServices]: conga,
    [DataSecurityAppName.CongaSchedule]: conga,
    [DataSecurityAppName.CongaSign]: conga,
    [DataSecurityAppName.ConnectAndSell]: connectandsell,
    [DataSecurityAppName.ConstantContact]: constantcontact,
    [DataSecurityAppName.ContactClean]: contactclean,
    [DataSecurityAppName.ContactOut]: contactout,
    [DataSecurityAppName.ContractBilling]: null,
    [DataSecurityAppName.Conversica]: conversica,
    [DataSecurityAppName.Conveyor]: conveyor,
    [DataSecurityAppName.Copado]: copado,
    [DataSecurityAppName.CopadoDevOps]: copado,
    [DataSecurityAppName.CopadoAIService]: copado,
    [DataSecurityAppName.CopadoRoboticTesting]: copado,
    [DataSecurityAppName.Correlated]: correlated,
    [DataSecurityAppName.CozyRoc]: null,
    [DataSecurityAppName.CPOMS]: cpoms,
    [DataSecurityAppName.Crayon]: crayon,
    [DataSecurityAppName.CrayonImpact]: crayon,
    [DataSecurityAppName.CRMPerks]: crmperks,
    [DataSecurityAppName.Crossbeam]: crossbeam,
    [DataSecurityAppName.CrossbeamSalesforce]: crossbeam,
    [DataSecurityAppName.CrossbeamSalesforceOverlaps]: crossbeam,
    [DataSecurityAppName.Crowdvocate]: crowdvocate,
    [DataSecurityAppName.Crunchbase]: crunchbase,
    [DataSecurityAppName.CTUCloneThisUser]: ctu,
    [DataSecurityAppName.CustomOrganizationIntegration]: null,
    [DataSecurityAppName.Customer360DataPlatform]: null,
    [DataSecurityAppName.CustomerDashboard]: null,
    [DataSecurityAppName.CustomerPortal]: null,
    [DataSecurityAppName.Cvent]: cvent,
    [DataSecurityAppName.DataAdminUser]: null,
    [DataSecurityAppName.DataAnalytics]: dataanalytics,
    [DataSecurityAppName.Databox]: databox,
    [DataSecurityAppName.DataChef]: datachef,
    [DataSecurityAppName.DataChef2]: datachef,
    [DataSecurityAppName.DataConnector]: null,
    [DataSecurityAppName.DataDog]: datadog,
    [DataSecurityAppName.DataDotCom]: sfdatacom,
    [DataSecurityAppName.DataFox]: datafox,
    [DataSecurityAppName.Dataiku]: dataiku,
    [DataSecurityAppName.DataImporter]: null,
    [DataSecurityAppName.DataLineage]: null,
    [DataSecurityAppName.DataLoader]: dataloader,
    [DataSecurityAppName.Dataloader]: dataloader,
    [DataSecurityAppName.DataLoaderBulk]: dataloader,
    [DataSecurityAppName.DataLoaderBulkUI]: dataloader,
    [DataSecurityAppName.DataLoaderIO]: dataloaderio,
    [DataSecurityAppName.DataLoaderPartner]: dataloader,
    [DataSecurityAppName.DataLoaderPartnerBatch]: dataloader,
    [DataSecurityAppName.DataMask]: datamask,
    [DataSecurityAppName.DBAmp]: null,
    [DataSecurityAppName.DBHoovers]: null,
    [DataSecurityAppName.DBSync]: null,
    [DataSecurityAppName.DCMIntegration]: null,
    [DataSecurityAppName.Dealhub]: dealhub,
    [DataSecurityAppName.DeetoInbound]: null,
    [DataSecurityAppName.DefHC]: defhc,
    [DataSecurityAppName.Delighted]: delighted,
    [DataSecurityAppName.Demandbase]: demandbase,
    [DataSecurityAppName.DemandbaseABM]: demandbase,
    [DataSecurityAppName.DemandbaseInc]: demandbase,
    [DataSecurityAppName.DemandTools]: demandtools,
    [DataSecurityAppName.DemandToolsV]: demandtools,
    [DataSecurityAppName.DemandTools26]: demandtools,
    [DataSecurityAppName.Deployment]: null,
    [DataSecurityAppName.DeskDotCom]: desk,
    [DataSecurityAppName.DevOpsCenter]: null,
    [DataSecurityAppName.Dialpad]: dialpad,
    [DataSecurityAppName.DialpadMeetings]: dialpad,
    [DataSecurityAppName.Dice]: null,
    [DataSecurityAppName.DiscoverOrg]: discoverorg,
    [DataSecurityAppName.DiscoveryDataLink]: discoverydata,
    [DataSecurityAppName.DiscoveryDataMarketLink]: discoverydata,
    [DataSecurityAppName.DistrEngineNC2]: nc2,
    [DataSecurityAppName.DMS]: dms,
    [DataSecurityAppName.DNBConnect]: dunandbradstreet,
    [DataSecurityAppName.DocSend]: docsend,
    [DataSecurityAppName.DocuFreeMailroom]: docufree,
    [DataSecurityAppName.Docusign]: docusign,
    [DataSecurityAppName.DocuSign]: docusign,
    [DataSecurityAppName.DocuSignConnect]: docusign,
    [DataSecurityAppName.DocuSignConnectSalesforce]: docusign,
    [DataSecurityAppName.Domo]: null,
    [DataSecurityAppName.Dooly]: dooly,
    [DataSecurityAppName.Drift]: drift,
    [DataSecurityAppName.DriftQA]: drift,
    [DataSecurityAppName.Dropbox]: docsend,
    [DataSecurityAppName.DSAppointments]: null,
    [DataSecurityAppName.DunAndBradstreet]: dunandbradstreet,
    [DataSecurityAppName.DuplicateCheck]: null,
    [DataSecurityAppName.DuplicateCheckSalesforce]: null,
    [DataSecurityAppName.Ebsta]: ebsta,
    [DataSecurityAppName.EditQuotas]: null,
    [DataSecurityAppName.EFile]: efile,
    [DataSecurityAppName.EKLA]: ekla,
    [DataSecurityAppName.Elements]: null,
    [DataSecurityAppName.ElfBrowser]: null,
    [DataSecurityAppName.enosiX]: enosix,
    [DataSecurityAppName.EnosixSDK]: enosix,
    [DataSecurityAppName.enosixSurface]: enosix,
    [DataSecurityAppName.EquilarExecAtlas]: equilar,
    [DataSecurityAppName.EventMonitoring]: null,
    [DataSecurityAppName.EverAfter]: null,
    [DataSecurityAppName.EverywhereTokenAuth]: null,
    [DataSecurityAppName.Exalate]: exalate,
    [DataSecurityAppName.ExecVision]: null,
    [DataSecurityAppName.ExploriumConnector]: null,
    [DataSecurityAppName.Expresiv]: null,
    [DataSecurityAppName.Fathom]: fathom,
    [DataSecurityAppName.FetchOpportunities]: null,
    [DataSecurityAppName.FieldCreator]: fieldcreator,
    [DataSecurityAppName.FieldFootprint]: null,
    [DataSecurityAppName.Fifteenfive]: fifteenfive,
    [DataSecurityAppName.FinancialForce]: financialforce,
    [DataSecurityAppName.FinancialForceERP]: financialforce,
    [DataSecurityAppName.FinancialForceInv]: financialforce,
    [DataSecurityAppName.Fintastic]: null,
    [DataSecurityAppName.Five9]: five9,
    [DataSecurityAppName.Fivetran]: fivetran,
    [DataSecurityAppName.FivetranDataLoader]: fivetran,
    [DataSecurityAppName.Fleetio]: fleetio,
    [DataSecurityAppName.Flosum]: flosom,
    [DataSecurityAppName.FlosumApplication]: flosom,
    [DataSecurityAppName.FlowActionsBasePack]: flow,
    [DataSecurityAppName.FlowAssist]: null,
    [DataSecurityAppName.Fluint]: null,
    [DataSecurityAppName.FluxCapacity]: fluxcapacity,
    [DataSecurityAppName.Folderize]: folderize,
    [DataSecurityAppName.Foresight]: null,
    [DataSecurityAppName.FormAssembly]: formassembly,
    [DataSecurityAppName.Formstack]: null,
    [DataSecurityAppName.Foundation]: null,
    [DataSecurityAppName.Freshdesk]: freshdesk,
    [DataSecurityAppName.Front]: front,
    [DataSecurityAppName.FullCircle]: fullcircle,
    [DataSecurityAppName.FundFormation]: null,
    [DataSecurityAppName.Funnel]: null,
    [DataSecurityAppName.G2Crowd]: g2crowd,
    [DataSecurityAppName.G2Crowd2]: g2crowd,
    [DataSecurityAppName.G2Track]: null,
    [DataSecurityAppName.Gainsight]: gainsight,
    [DataSecurityAppName.GainsightApp]: gainsight,
    [DataSecurityAppName.Gcom]: null,
    [DataSecurityAppName.GConnector]: null,
    [DataSecurityAppName.Gearset]: gearset,
    [DataSecurityAppName.GearsetDeploy]: gearset,
    [DataSecurityAppName.Geckoboard]: geckoboard,
    [DataSecurityAppName.Genesys]: genesys,
    [DataSecurityAppName.Geopointe]: geopointe,
    [DataSecurityAppName.Gepeto]: null,
    [DataSecurityAppName.GetFeedback]: getfeedback,
    [DataSecurityAppName.Getint]: null,
    [DataSecurityAppName.Glean]: glean,
    [DataSecurityAppName.Goldcast]: null,
    [DataSecurityAppName.Gong]: gong,
    [DataSecurityAppName.GongCanvas]: gong,
    [DataSecurityAppName.GongDealsCanvas]: gong,
    [DataSecurityAppName.GongIntegration]: gong,
    [DataSecurityAppName.GongUserConnection]: gong,
    [DataSecurityAppName.Google]: google,
    [DataSecurityAppName.GoogleAds]: googleads,
    [DataSecurityAppName.GoogleAdsDataManagerAuth1]: googleads,
    [DataSecurityAppName.GoogleAdsDataManagerAuth2]: googleads,
    [DataSecurityAppName.GoogleAdsDataManagerAuth3]: googleads,
    [DataSecurityAppName.GoogleAdWords]: null,
    [DataSecurityAppName.GoogleAdWords2]: null,
    [DataSecurityAppName.GoogleAdWordsConversionImport]: null,
    [DataSecurityAppName.GoogleDataStudioConnector]: null,
    [DataSecurityAppName.GoToGroup]: null,
    [DataSecurityAppName.GPVIntegration]: null,
    [DataSecurityAppName.Grafana]: grafana,
    [DataSecurityAppName.GrafanaAPITesting]: grafana,
    [DataSecurityAppName.GrafanaCom]: grafana,
    [DataSecurityAppName.GrafanaOps]: grafana,
    [DataSecurityAppName.Grain]: grain,
    [DataSecurityAppName.GRC]: null,
    [DataSecurityAppName.GridBuddy]: gridbuddy,
    [DataSecurityAppName.Groove]: groove,
    [DataSecurityAppName.GrooveDevelopment]: groove,
    [DataSecurityAppName.GrowBIDashboard]: null,
    [DataSecurityAppName.GuideCX]: guide,
    [DataSecurityAppName.Guru]: null,
    [DataSecurityAppName.HackerOne]: hackerone,
    [DataSecurityAppName.HappySoup]: null,
    [DataSecurityAppName.HeadlightDataIngest]: headlight,
    [DataSecurityAppName.Heap]: heap,
    [DataSecurityAppName.HeapIntegration]: heap,
    [DataSecurityAppName.HelloSign]: hellosign,
    [DataSecurityAppName.Heroku]: heroku,
    [DataSecurityAppName.Heymarket]: heymarket,
    [DataSecurityAppName.HGConnect]: null,
    [DataSecurityAppName.HGData]: hgdata,
    [DataSecurityAppName.Highspot]: highspot,
    [DataSecurityAppName.Hightouch]: hightouch,
    [DataSecurityAppName.HippoVideo]: hippovideo,
    [DataSecurityAppName.HockeyStack]: hockeystack,
    [DataSecurityAppName.HookConnector]: null,
    [DataSecurityAppName.HubConnect]: null,
    [DataSecurityAppName.HubIntegration]: null,
    [DataSecurityAppName.Hubspot]: hubspot,
    [DataSecurityAppName.ICapture]: null,
    [DataSecurityAppName.IEnterprises]: ienterprises,
    [DataSecurityAppName.IEnterprisesEmail]: ienterprises,
    [DataSecurityAppName.Impartner]: impartner,
    [DataSecurityAppName.ImpartnerMDF]: impartner,
    [DataSecurityAppName.Incoming]: null,
    [DataSecurityAppName.InflProductionRotated]: null,
    [DataSecurityAppName.Informatica]: informatica,
    [DataSecurityAppName.InMoment]: inmoment,
    [DataSecurityAppName.InSided]: insided,
    [DataSecurityAppName.Insights]: insights,
    [DataSecurityAppName.InsightSquared]: insightsquared,
    [DataSecurityAppName.Instapage]: instapage,
    [DataSecurityAppName.Insycle]: insycle,
    [DataSecurityAppName.IntacctAdvanced]: intacct,
    [DataSecurityAppName.IntacctConnect]: intacct,
    [DataSecurityAppName.IntacctContract]: intacct,
    [DataSecurityAppName.Intail]: null,
    [DataSecurityAppName.Intake]: null,
    [DataSecurityAppName.IntegratorIo]: integratorio,
    [DataSecurityAppName.Integrator_IO]: integratorio,
    [DataSecurityAppName.Intercom]: intercom,
    [DataSecurityAppName.IntercombySalesforce]: intercom,
    [DataSecurityAppName.Intricately]: null,
    [DataSecurityAppName.Introhive]: introhive,
    [DataSecurityAppName.IntrohiveNA2]: introhive,
    [DataSecurityAppName.Ironclad]: ironclad,
    [DataSecurityAppName.JenkinsBuildServer]: null,
    [DataSecurityAppName.Jetstream]: null,
    [DataSecurityAppName.JetstreamAuth]: null,
    [DataSecurityAppName.Jira]: jira,
    [DataSecurityAppName.JiraIntegration]: jira,
    [DataSecurityAppName.JiraSalesforce]: jira,
    [DataSecurityAppName.JotForm]: null,
    [DataSecurityAppName.JWT]: null,
    [DataSecurityAppName.Khoros]: khoros,
    [DataSecurityAppName.Kimble]: kimble,
    [DataSecurityAppName.KingswaySoft]: kingswaysoft,
    [DataSecurityAppName.Kixie]: kixie,
    [DataSecurityAppName.Klaus]: null,
    [DataSecurityAppName.Kochava]: kochava,
    [DataSecurityAppName.Koncert]: koncert,
    [DataSecurityAppName.KotlikovBot]: null,
    [DataSecurityAppName.LaunchPad]: null,
    [DataSecurityAppName.Lavendar]: null,
    [DataSecurityAppName.LavendarNew]: null,
    [DataSecurityAppName.LavendarSFDC]: null,
    [DataSecurityAppName.Leadfeeder]: leadfeeder,
    [DataSecurityAppName.LeadIQ]: leadiq,
    [DataSecurityAppName.LeanData]: leandata,
    [DataSecurityAppName.LeanDataOL]: leandata,
    [DataSecurityAppName.LearnUpon]: learnupon,
    [DataSecurityAppName.LightningConfiguration]: null,
    [DataSecurityAppName.LightningObjectCreator]: null,
    [DataSecurityAppName.LightningReadiness]: null,
    [DataSecurityAppName.LightningSharing]: null,
    [DataSecurityAppName.Linen]: linen,
    [DataSecurityAppName.LinenIntegration]: linen,
    [DataSecurityAppName.LinkedIn]: linkedin,
    [DataSecurityAppName.LinkedInSalesNavigator]: linkedin,
    [DataSecurityAppName.LinkedInSalesNavigatorWriteback]: linkedin,
    [DataSecurityAppName.LinkPoint360]: linkpoint360,
    [DataSecurityAppName.LinkSquares]: linksquares,
    [DataSecurityAppName.LinqProduction]: null,
    [DataSecurityAppName.LiveChat]: livechat,
    [DataSecurityAppName.LivePerson]: liveperson,
    [DataSecurityAppName.LMSILT]: lms,
    [DataSecurityAppName.LMSLearning]: lms,
    [DataSecurityAppName.LoadAgent]: null,
    [DataSecurityAppName.LocalDevelopmentConnection]: null,
    [DataSecurityAppName.LookupHelper]: null,
    [DataSecurityAppName.Loop]: loop,
    [DataSecurityAppName.Loopio]: loopio,
    [DataSecurityAppName.Lucidchart]: lucidchart,
    [DataSecurityAppName.Lusha]: lusha,
    [DataSecurityAppName.LWC]: null,
    [DataSecurityAppName.MadCap]: madcap,
    [DataSecurityAppName.MadCapConnect]: madcap,
    [DataSecurityAppName.MadKudu]: madkudu,
    [DataSecurityAppName.MadKuduConnectedApp]: madkudu,
    [DataSecurityAppName.MaestroQA]: maestroqa,
    [DataSecurityAppName.Magentrix]: magentrix,
    [DataSecurityAppName.MagentrixSiteSalesforce]: magentrix,
    [DataSecurityAppName.MagicMover]: magicmover,
    [DataSecurityAppName.Mailchimp]: mailchimp,
    [DataSecurityAppName.Make]: make,
    [DataSecurityAppName.Malbek]: malbek,
    [DataSecurityAppName.Map]: null,
    [DataSecurityAppName.MapAnything]: sfmaps,
    [DataSecurityAppName.MarketingAnalytics]: null,
    [DataSecurityAppName.MarketingCloud]: sfmarketingcloud,
    [DataSecurityAppName.MarketingCloudIntegration]: sfmarketingcloud,
    [DataSecurityAppName.Marketo]: marketo,
    [DataSecurityAppName.MarketoLeadMgm]: marketo,
    [DataSecurityAppName.MarketoNew]: marketo,
    [DataSecurityAppName.MarketoOAuth]: marketo,
    [DataSecurityAppName.MatchMyEmail]: null,
    [DataSecurityAppName.Matik]: matik,
    [DataSecurityAppName.MavenTools]: null,
    [DataSecurityAppName.Maxio]: maxio,
    [DataSecurityAppName.MaxioPlatformIntegration]: maxio,
    [DataSecurityAppName.MDComp]: null,
    [DataSecurityAppName.MedicaRecordService]: null,
    [DataSecurityAppName.Merge]: null,
    [DataSecurityAppName.MergeTest]: null,
    [DataSecurityAppName.MetadataSF]: null,
    [DataSecurityAppName.Metallic]: null,
    [DataSecurityAppName.MicrosoftCloudAppSecurity]: microsoft,
    [DataSecurityAppName.MicrosoftCloudAppSecurityUSW2]: microsoft,
    [DataSecurityAppName.MicrosoftConnectors]: microsoft,
    [DataSecurityAppName.MicrosoftGraphConnectors]: microsoft,
    [DataSecurityAppName.MicrosoftPowerPlatform]: microsoft,
    [DataSecurityAppName.MicrosoftPowerQuery]: microsoft,
    [DataSecurityAppName.MicrosoftPowerQueryRefresh]: microsoft,
    [DataSecurityAppName.MilestonesPM]: milestones,
    [DataSecurityAppName.Mindtickle]: mindtickle,
    [DataSecurityAppName.MindtickleOAuth]: mindtickle,
    [DataSecurityAppName.Minoa]: null,
    [DataSecurityAppName.MinoaMerge]: null,
    [DataSecurityAppName.MissionControl]: missioncontrol,
    [DataSecurityAppName.Modigie]: modigie,
    [DataSecurityAppName.Mosaic]: null,
    [DataSecurityAppName.Momentum]: null,
    [DataSecurityAppName.Monday]: monday,
    [DataSecurityAppName.MondayDotCom]: monday,
    [DataSecurityAppName.MovableInk]: movableink,
    [DataSecurityAppName.MSCI]: msci,
    [DataSecurityAppName.MSCIAnalytics]: msci,
    [DataSecurityAppName.MSCIApps]: msci,
    [DataSecurityAppName.MSCIEntitlements]: msci,
    [DataSecurityAppName.MSCIIAM]: msci,
    [DataSecurityAppName.MSCIOne]: msci,
    [DataSecurityAppName.MSCIService]: msci,
    [DataSecurityAppName.MTIQuery]: null,
    [DataSecurityAppName.Mulesoft]: mulesoft,
    [DataSecurityAppName.MulesoftAPI]: mulesoft,
    [DataSecurityAppName.MulesoftPlatform]: mulesoft,
    [DataSecurityAppName.Mutiny]: null,
    [DataSecurityAppName.MultiViewCalendar]: multiview,
    [DataSecurityAppName.myViews]: null,
    [DataSecurityAppName.nCino]: ncino,
    [DataSecurityAppName.NavigateButton]: null,
    [DataSecurityAppName.Netchex]: netchex,
    [DataSecurityAppName.NetForm]: null,
    [DataSecurityAppName.Netskope]: netskope,
    [DataSecurityAppName.NetSuiteConnector]: netsuite,
    [DataSecurityAppName.NewRelic]: null,
    [DataSecurityAppName.NewVoicMedia]: null,
    [DataSecurityAppName.NewVoicMediaAPI]: null,
    [DataSecurityAppName.Nexus]: null,
    [DataSecurityAppName.NICEinContact]: niceincontact,
    [DataSecurityAppName.Nightfall]: nightfall,
    [DataSecurityAppName.NintexDocGen]: nintex,
    [DataSecurityAppName.NPSP]: npsp,
    [DataSecurityAppName.Nooks]: null,
    [DataSecurityAppName.NRAInvoicesBatch]: null,
    [DataSecurityAppName.Nue]: null,
    [DataSecurityAppName.Octoboard]: null,
    [DataSecurityAppName.OIQIntegraion]: null,
    [DataSecurityAppName.Okta]: okta,
    [DataSecurityAppName.OktaImports]: okta,
    [DataSecurityAppName.OktaIntegration]: okta,
    [DataSecurityAppName.OktaProvisioning]: okta,
    [DataSecurityAppName.OktaSCIM]: okta,
    [DataSecurityAppName.OktaWorkflows]: okta,
    [DataSecurityAppName.OktaSFDCProvisioning]: okta,
    [DataSecurityAppName.Oktopost]: oktopost,
    [DataSecurityAppName.Oneflow]: oneflow,
    [DataSecurityAppName.OneClickUpdate]: oneclickupdate,
    [DataSecurityAppName.OneMSCIEntitlementPlatform]: null,
    [DataSecurityAppName.OneTrust]: onetrust,
    [DataSecurityAppName.OnRamp]: onramp,
    [DataSecurityAppName.OpenpriseCloud]: null,
    [DataSecurityAppName.OperationsSchedulingAutomation]: null,
    [DataSecurityAppName.OrcaPlus]: null,
    [DataSecurityAppName.OrchestrateSetup]: orchestrate,
    [DataSecurityAppName.OrgChartPlus]: orgchartplus,
    [DataSecurityAppName.OrigamiClaims]: null,
    [DataSecurityAppName.Orum]: orum,
    [DataSecurityAppName.OtterAI]: null,
    [DataSecurityAppName.OutlookIntegrationRiva]: null,
    [DataSecurityAppName.Outreach]: outreach,
    [DataSecurityAppName.OutreachLivechat]: outreach,
    [DataSecurityAppName.OwnForSalesforce]: null,
    [DataSecurityAppName.OwnForSalesforceMetadata]: null,
    [DataSecurityAppName.OwnForSalesforceSandbox]: null,
    [DataSecurityAppName.OwnBackup]: null,
    [DataSecurityAppName.OwnBackupForSalesforce]: null,
    [DataSecurityAppName.PagerDuty]: pagerduty,
    [DataSecurityAppName.PandaDoc]: pandadoc,
    [DataSecurityAppName.PandaDocOAuth2]: pandadoc,
    [DataSecurityAppName.Pardot]: pardot,
    [DataSecurityAppName.PardotAPI]: pardot,
    [DataSecurityAppName.PardotSSO]: pardot,
    [DataSecurityAppName.PardotSecure]: pardot,
    [DataSecurityAppName.PartnerFleet]: null,
    [DataSecurityAppName.PartnerSignup]: null,
    [DataSecurityAppName.PartnerSuccessConnect]: null,
    [DataSecurityAppName.PartnerTap]: null,
    [DataSecurityAppName.PatternDataDocumentExport]: null,
    [DataSecurityAppName.Pendo]: pendo,
    [DataSecurityAppName.PendoIntegration]: pendo,
    [DataSecurityAppName.PeopleAI]: peopleai,
    [DataSecurityAppName.PeopleDotAI]: peopleai,
    [DataSecurityAppName.PeopleImport]: null,
    [DataSecurityAppName.Performio]: null,
    [DataSecurityAppName.PermComparator]: null,
    [DataSecurityAppName.Pigment]: null,
    [DataSecurityAppName.Pipe17]: pipe17,
    [DataSecurityAppName.PitchBook]: pitchbook,
    [DataSecurityAppName.PlanhatSandboxes]: planhat,
    [DataSecurityAppName.PlanhatUS]: planhat,
    [DataSecurityAppName.Planthat]: null,
    [DataSecurityAppName.PolarisLicense]: null,
    [DataSecurityAppName.Polytomic]: polytomic,
    [DataSecurityAppName.Popl]: null,
    [DataSecurityAppName.PortalIntegration]: null,
    [DataSecurityAppName.Postal]: null,
    [DataSecurityAppName.Postman]: null,
    [DataSecurityAppName.PowerAutomation]: null,
    [DataSecurityAppName.PowerAutomationUser]: null,
    [DataSecurityAppName.PowerBI]: powerbi,
    [DataSecurityAppName.PowerSpaceBI]: powerbi,
    [DataSecurityAppName.PowerOfUsHub]: null,
    [DataSecurityAppName.ProdlyDeployment]: null,
    [DataSecurityAppName.ProdoscoreLive]: null,
    [DataSecurityAppName.Productboard]: productboard,
    [DataSecurityAppName.Productiv]: productiv,
    [DataSecurityAppName.ProgressiveIntegration]: null,
    [DataSecurityAppName.Propel]: propel,
    [DataSecurityAppName.Prospect]: null,
    [DataSecurityAppName.Qualified]: qualified,
    [DataSecurityAppName.Qualtrics]: qualtrics,
    [DataSecurityAppName.QualtricsIntegration]: qualtrics,
    [DataSecurityAppName.QualtricsSurvey]: qualtrics,
    [DataSecurityAppName.QuickBasePipelines]: quickbase,
    [DataSecurityAppName.QuickbaseSync]: quickbase,
    [DataSecurityAppName.Quip]: quip,
    [DataSecurityAppName.QuotaPath]: quotapath,
    [DataSecurityAppName.Qwilr]: qwilr,
    [DataSecurityAppName.RallySupportManager]: null,
    [DataSecurityAppName.Rampmetrics]: rampmetrics,
    [DataSecurityAppName.RaptorCommunitySSO]: null,
    [DataSecurityAppName.Rattle]: null,
    [DataSecurityAppName.RCCCAPI]: null,
    [DataSecurityAppName.Reachdesk]: reachdesk,
    [DataSecurityAppName.ReadAI]: null,
    [DataSecurityAppName.Receptive]: null,
    [DataSecurityAppName.ReferenceEdge]: referenceedge,
    [DataSecurityAppName.RegieAI]: regieai,
    [DataSecurityAppName.Responsive]: null,
    [DataSecurityAppName.Retail]: null,
    [DataSecurityAppName.Retool]: retool,
    [DataSecurityAppName.Reveal]: reveal,
    [DataSecurityAppName.RevenueGrid]: revenuegrid,
    [DataSecurityAppName.RevenueInbox]: null,
    [DataSecurityAppName.RevSend]: revsend,
    [DataSecurityAppName.RightRevRevRec]: rightrev,
    [DataSecurityAppName.RingDNA]: ringdna,
    [DataSecurityAppName.RingLead]: zoominfo,
    [DataSecurityAppName.Rippling]: rippling,
    [DataSecurityAppName.Riva]: null,
    [DataSecurityAppName.RivaForSalesforce]: null,
    [DataSecurityAppName.RLAccess]: null,
    [DataSecurityAppName.RMGAPI]: null,
    [DataSecurityAppName.RMKRViewCentral]: null,
    [DataSecurityAppName.Rocketlane]: rocketlane,
    [DataSecurityAppName.RocketReachSalesForceSync]: null,
    [DataSecurityAppName.RollupHelper]: rolluphelper,
    [DataSecurityAppName.RollupSummary]: rollupsummary,
    [DataSecurityAppName.RubyRevenueBuilder]: null,
    [DataSecurityAppName.S4G]: null,
    [DataSecurityAppName.SaaSWorks]: null,
    [DataSecurityAppName.Savebase]: null,
    [DataSecurityAppName.SailpointIntegration]: null,
    [DataSecurityAppName.SalesCloud]: null,
    [DataSecurityAppName.SalesforceAdvancedSearch]: salesforce,
    [DataSecurityAppName.SalesforceAPIForDashboard]: salesforce,
    [DataSecurityAppName.SalesforceForAndroid]: salesforce,
    [DataSecurityAppName.SalesforceBackend]: salesforce,
    [DataSecurityAppName.SalesforceBilling]: sfbilling,
    [DataSecurityAppName.SalesforceChangeSetHelper]: salesforce,
    [DataSecurityAppName.SalesforceChatter]: sfchatter,
    [DataSecurityAppName.SalesforceCLI]: salesforce,
    [DataSecurityAppName.SalesforceComplianceSite]: salesforce,
    [DataSecurityAppName.SalesforceConnector]: salesforce,
    [DataSecurityAppName.SalesforceDevelopers]: salesforce,
    [DataSecurityAppName.SalesforceDevTools]: salesforce,
    [DataSecurityAppName.SalesforceDigitalTbid]: salesforce,
    [DataSecurityAppName.SalesforceFieldServiceForAndroid]: salesforce,
    [DataSecurityAppName.SalesforceFieldServiceForiOS]: salesforce,
    [DataSecurityAppName.SalesforceFunctions]: salesforce,
    [DataSecurityAppName.SalesforceHelp]: salesforce,
    [DataSecurityAppName.SalesforceInputTool]: salesforce,
    [DataSecurityAppName.SalesforceInspectorreloaded]: salesforce,
    [DataSecurityAppName.SalesforceIQ]: salesforceiq,
    [DataSecurityAppName.SalesforceIQInbox]: sfinbox,
    [DataSecurityAppName.SalesforceForiOS]: salesforce,
    [DataSecurityAppName.SalesforceMaps]: sfmaps,
    [DataSecurityAppName.SalesforceMarketingCloud]: sfmarketingcloud,
    [DataSecurityAppName.SalesforceOrgDoctor]: salesforce,
    [DataSecurityAppName.SalesforceforOutlook]: salesforce,
    [DataSecurityAppName.SalesforcePartnerCommunity]: salesforce,
    [DataSecurityAppName.SalesforceProductboardIntegration]: salesforce,
    [DataSecurityAppName.SalesforceSecurityAndComplianceSite]: salesforce,
    [DataSecurityAppName.SalesforceSwitch]: salesforce,
    [DataSecurityAppName.SalesHoodPlugin]: saleshood,
    [DataSecurityAppName.SalesInsights]: salesinsights,
    [DataSecurityAppName.Salesloft]: salesloft,
    [DataSecurityAppName.SalesLoftQA]: salesloft,
    [DataSecurityAppName.SalesQ]: null,
    [DataSecurityAppName.SalesScreen]: salesscreen,
    [DataSecurityAppName.SalesSpaceScreen]: salesscreen,
    [DataSecurityAppName.Saleswhale]: null,
    [DataSecurityAppName.Salto]: null,
    [DataSecurityAppName.ScanBizCardsBusinessCardReader]: null,
    [DataSecurityAppName.Scratchpad]: scratchpad,
    [DataSecurityAppName.SeamlessAI]: null,
    [DataSecurityAppName.SeaMonster]: null,
    [DataSecurityAppName.SearchUnify]: searchunify,
    [DataSecurityAppName.Secoda]: secoda,
    [DataSecurityAppName.Segment]: null,
    [DataSecurityAppName.Seismic]: seismic,
    [DataSecurityAppName.SeismicOAUTH]: seismic,
    [DataSecurityAppName.SeismicBusinessDataEnrichment]: seismic,
    [DataSecurityAppName.Sendoso]: sendoso,
    [DataSecurityAppName.Sentinel]: null,
    [DataSecurityAppName.ServiceCloudArticleInt]: null,
    [DataSecurityAppName.SEToolsSFDC]: null,
    [DataSecurityAppName.SFAdminConApps]: sfconnappsadmin,
    [DataSecurityAppName.SFAgileAccelerator]: sfagileaccelerator,
    [DataSecurityAppName.SFChatterApps]: sfchatter,
    [DataSecurityAppName.SFCommunities]: sfcommunities,
    [DataSecurityAppName.SFConnectedApps]: sfconnectedapps,
    [DataSecurityAppName.SFDev]: null,
    [DataSecurityAppName.SFExplorer]: null,
    [DataSecurityAppName.sflowsalesforce]: null,
    [DataSecurityAppName.SFSync]: null,
    [DataSecurityAppName.SFUserAPI]: null,
    [DataSecurityAppName.SFDCAnalyticsHeadlessBrowserService]: null,
    [DataSecurityAppName.SFDCChannelOrder]: null,
    [DataSecurityAppName.SFDCSiqActivityPlatform]: null,
    [DataSecurityAppName.SFDCSIQActivitySyncEngine]: null,
    [DataSecurityAppName.SFDCSIQCloudActivity]: null,
    [DataSecurityAppName.SFDCSIQEngagement]: null,
    [DataSecurityAppName.ShoptechConnectedApp]: null,
    [DataSecurityAppName.Showpad]: showpad,
    [DataSecurityAppName.ShowpadSalesforceIntegration]: showpad,
    [DataSecurityAppName.Sifdata]: sifdata,
    [DataSecurityAppName.Sigstr]: sigstr,
    [DataSecurityAppName.SimbaTechnologies]: null,
    [DataSecurityAppName.SimbaTechnologiesDriver]: null,
    [DataSecurityAppName.Simpplr]: simpplr,
    [DataSecurityAppName.SixSense]: sixsense,
    [DataSecurityAppName.SixSenseOauth]: sixsense,
    [DataSecurityAppName.Skilljar]: skilljar,
    [DataSecurityAppName.SkilljarAPI]: skilljar,
    [DataSecurityAppName.Slack]: slack,
    [DataSecurityAppName.Slapdash]: slapdash,
    [DataSecurityAppName.SmartlingKnowledge]: smartling,
    [DataSecurityAppName.SMSMagicUS]: null,
    [DataSecurityAppName.SNforSFDC]: snforsfdc,
    [DataSecurityAppName.Sonar]: arovy,
    [DataSecurityAppName.SonarDevelopment]: arovy,
    [DataSecurityAppName.SonarStaging]: arovy,
    [DataSecurityAppName.SoqlX]: null,
    [DataSecurityAppName.SpanningBackup]: spanningbackup,
    [DataSecurityAppName.Spekit]: spekit,
    [DataSecurityAppName.Spiff]: spiff,
    [DataSecurityAppName.Splash]: null,
    [DataSecurityAppName.SplashSalesforceIntegration]: null,
    [DataSecurityAppName.SPMPackages]: null,
    [DataSecurityAppName.Spoton]: spoton,
    [DataSecurityAppName.SpringCM]: null,
    [DataSecurityAppName.Squivr]: squivr,
    [DataSecurityAppName.StackMoxie]: stackmoxie,
    [DataSecurityAppName.StackMoxieRTM]: stackmoxie,
    [DataSecurityAppName.Staffingsurvey]: null,
    [DataSecurityAppName.StaircaseAI]: null,
    [DataSecurityAppName.StarSan]: null,
    [DataSecurityAppName.StartDeliver]: startdeliver,
    [DataSecurityAppName.SteelbrickCPQ]: steelbrick,
    [DataSecurityAppName.Stitch]: null,
    [DataSecurityAppName.StullerAPI]: null,
    [DataSecurityAppName.Suger]: null,
    [DataSecurityAppName.SumologicEventMonitoring]: sumologic,
    [DataSecurityAppName.Superhuman]: superhuman,
    [DataSecurityAppName.Supermetrics]: supermetrics,
    [DataSecurityAppName.Surfboard]: null,
    [DataSecurityAppName.Surfe]: null,
    [DataSecurityAppName.SurveyMonkey]: surveymonkey,
    [DataSecurityAppName.SurveyMonkeySalesforce]: surveymonkey,
    [DataSecurityAppName.SWATELA]: null,
    [DataSecurityAppName.Sweep]: null,
    [DataSecurityAppName.SwitchGrowth]: switchgrowth,
    [DataSecurityAppName.Swoogo]: null,
    [DataSecurityAppName.Tableau]: tableau,
    [DataSecurityAppName.TableauViz]: tableau,
    [DataSecurityAppName.TableauDesktop]: tableau,
    [DataSecurityAppName.TableauID]: tableau,
    [DataSecurityAppName.TableauOnline]: tableau,
    [DataSecurityAppName.TableauOnlineSalesforce]: tableau,
    [DataSecurityAppName.TableauTackleRefreshToken]: tableau,
    [DataSecurityAppName.TableauServer]: tableau,
    [DataSecurityAppName.Talkdesk]: talkdesk,
    [DataSecurityAppName.Taralex]: null,
    [DataSecurityAppName.Taralex2]: null,
    [DataSecurityAppName.Taskray]: taskray,
    [DataSecurityAppName.TeableauOnline]: null,
    [DataSecurityAppName.TeamPages]: null,
    [DataSecurityAppName.TechAccelerator]: null,
    [DataSecurityAppName.TechTargetPriority]: techtarget,
    [DataSecurityAppName.TemplateVizArt]: null,
    [DataSecurityAppName.Terminus]: terminus,
    [DataSecurityAppName.TerminusMy]: terminus,
    [DataSecurityAppName.Tesorio]: tesorio,
    [DataSecurityAppName.ThenaRequests]: null,
    [DataSecurityAppName.Thnks]: thnks,
    [DataSecurityAppName.ThoughtIndustries]: null,
    [DataSecurityAppName.Tibco]: tibco,
    [DataSecurityAppName.TibcoScribe]: tibco,
    [DataSecurityAppName.TibcoScribeOnline]: tibco,
    [DataSecurityAppName.Tonkean]: tonkean,
    [DataSecurityAppName.Totango]: totango,
    [DataSecurityAppName.TractionGuest]: tractionguest,
    [DataSecurityAppName.TractionHierarchies]: tractionhierarchies,
    [DataSecurityAppName.Trailblazer]: null,
    [DataSecurityAppName.Trailhead]: trailhead,
    [DataSecurityAppName.TrailheadConnected]: null,
    [DataSecurityAppName.Trayio]: trayio,
    [DataSecurityAppName.Treehouse]: null,
    [DataSecurityAppName.Truly]: null,
    [DataSecurityAppName.TrustRadius]: trustradius,
    [DataSecurityAppName.TryProspect]: null,
    [DataSecurityAppName.Twitter]: twitter,
    [DataSecurityAppName.UIPath]: uipath,
    [DataSecurityAppName.UIPathProdVM1]: uipath,
    [DataSecurityAppName.UIPathProdVM2]: uipath,
    [DataSecurityAppName.UIPathProdVM3]: uipath,
    [DataSecurityAppName.UIPathProdVM4]: uipath,
    [DataSecurityAppName.UIPathProdVM5]: uipath,
    [DataSecurityAppName.UIPathProdVM6]: uipath,
    [DataSecurityAppName.UIPathProdVM7]: uipath,
    [DataSecurityAppName.UIPathProdVM8]: uipath,
    [DataSecurityAppName.UIPathTestVM1]: uipath,
    [DataSecurityAppName.UKG]: ukg,
    [DataSecurityAppName.Unleash]: null,
    [DataSecurityAppName.UniqueEntry]: null,
    [DataSecurityAppName.Unify]: unify,
    [DataSecurityAppName.UserGems]: usergems,
    [DataSecurityAppName.UserVoice]: uservoice,
    [DataSecurityAppName.Valooto]: valooto,
    [DataSecurityAppName.Valence]: null,
    [DataSecurityAppName.Validity]: validity,
    [DataSecurityAppName.ValueCloud]: valuecloud,
    [DataSecurityAppName.Vanta]: vanta,
    [DataSecurityAppName.VantaAPI]: vanta,
    [DataSecurityAppName.VantaEventMonitoring]: vanta,
    [DataSecurityAppName.Varonis]: varonis,
    [DataSecurityAppName.VaronisCloud]: varonis,
    [DataSecurityAppName.Veritas]: null,
    [DataSecurityAppName.Veza]: veza,
    [DataSecurityAppName.Vidyard]: vidyard,
    [DataSecurityAppName.Vista]: vista,
    [DataSecurityAppName.VisualAntidote]: visualantidote,
    [DataSecurityAppName.Vitally]: null,
    [DataSecurityAppName.VivunInc]: vivun,
    [DataSecurityAppName.Vocalo]: null,
    [DataSecurityAppName.Vonage]: vonage,
    [DataSecurityAppName.VonageAutoDialer]: vonage,
    [DataSecurityAppName.VonageIntegrationSuite]: vonage,
    [DataSecurityAppName.WalkMe]: walkme,
    [DataSecurityAppName.WaveWeb]: null,
    [DataSecurityAppName.WebinfinityPRM]: webinfinity,
    [DataSecurityAppName.WFMConnected]: null,
    [DataSecurityAppName.WhatfixCrawler]: whatfix,
    [DataSecurityAppName.WingSecurity]: null,
    [DataSecurityAppName.Wootric]: wootric,
    [DataSecurityAppName.Workato]: workato,
    [DataSecurityAppName.WorkatoConnector]: workato,
    [DataSecurityAppName.Workbench]: null,
    [DataSecurityAppName.WorkRampLegacy]: workramp,
    [DataSecurityAppName.WorkRamp]: workramp,
    [DataSecurityAppName.Xactly]: xactly,
    [DataSecurityAppName.Xactly2]: xactly,
    [DataSecurityAppName.XactlyExpress]: xactlyexpress,
    [DataSecurityAppName.Xappex]: xappex,
    [DataSecurityAppName.XappexConnector]: xappex,
    [DataSecurityAppName.XappexConnectorLite]: xappex,
    [DataSecurityAppName.XLConnector]: null,
    [DataSecurityAppName.XLConnector365]: null,
    [DataSecurityAppName.XLConnectorTeamPlayer]: null,
    [DataSecurityAppName.Xplenty]: xplenty,
    [DataSecurityAppName.Yaypay]: yaypay,
    [DataSecurityAppName.Yesware]: yesware,
    [DataSecurityAppName.YoCierge]: yoCierge,
    [DataSecurityAppName.zAgileConnect]: null,
    [DataSecurityAppName.Zapier]: zapier,
    [DataSecurityAppName.Zendesk]: zendesk,
    [DataSecurityAppName.ZendeskIntegration]: zendesk,
    [DataSecurityAppName.Zenkraft]: zenkraft,
    [DataSecurityAppName.ZenKraftBulk]: zenkraft,
    [DataSecurityAppName.ZigPR]: zigpr,
    [DataSecurityAppName.Zoom]: zoom,
    [DataSecurityAppName.ZoomContactCenter]: zoom,
    [DataSecurityAppName.ZoomIntegrations]: zoom,
    [DataSecurityAppName.ZoomInfo]: zoominfo,
    [DataSecurityAppName.ZoomInfoIntegration]: zoominfo,
    [DataSecurityAppName.Zuora]: zuora,
    [DataSecurityAppName.Zuora360]: zuora,
    [DataSecurityAppName.ZuoraCRM]: zuora,
    [DataSecurityAppName.ZuoraQuotes]: zuora,
    [DataSecurityAppName.Zuoraz360]: zuora,
    [DataSecurityAppName.Zuorazforce]: zuora,
    [DataSecurityAppName.Zylo]: zylo,
    [DataSecurityAppName.ZyloIntegration]: zylo,
    [DataSecurityAppName.ZynSync]: null
};
